import React from 'react';
import { useEffectWithErrorLogging } from 'src/utils/useEffectWithErrorLogging';
import { useSelector, useDispatch } from 'react-redux';
import {
    TransferSurgeryErrorDiv,
    TransferSurgeryErrorTitlerDiv,
    TransferSurgeryRedText,
    TransferSurgeryBlackText,
} from 'src/pages/scheduleSurgery/components/shipping/NonTissueProductCard.styled';
import StyledText from 'src/common/refactoredComponents/styledText/StyledText';
import Checkbox from 'src/common/refactoredComponents/checkbox/Checkbox';
import { useTranslation } from 'react-i18next';
import DropdownWithErrorText from './DropdownWithError';
import { updateCartDataShipping } from 'src/pages/scheduleSurgery/redux/actions';
import ErrorOutlineRounded from '@material-ui/icons/ErrorOutlineRounded';
import { avoidDeploymentType } from 'src/utils/util';
import { DARK_GRAY_FONT_COLOR, DARK_NAVY_FONT_COLOR, FONT_FAMILY_DEMI, SEMANTIC_TEXT_SMALL_PX, SMALL_TEXT_PX } from 'src/styles/fonts/MCFontConstants';

const NtCheckboxwithTransferFailedWithDropdown = ({
    checkBoxClick,
    inventoryShipping,
    AlertCircleOutline,
    nonTissueProduct,
    batchLocations,
    selectedBatchLocationTemplate,
    checked,
    batchLocationTemplate,
    selectedLocation,
    handleLocationChange,
    isShowCheckBox = false,
    isMessageDisplay = false,
    isShowLabelEmpty = false,
    isShowSetLocation = true,
    isShowDropDown = true,
}) => {
    const { t } = useTranslation();
    const dispatch = useDispatch();
    const { productKey } = nonTissueProduct;
    const visitedShipping = useSelector(
        (state) => state.surgeryReducer.visitedShipping
    );
    const countryISOCode = useSelector(
        (state) => state.loginReducer.hybrisUserDetails.countryISOCode
    );
    const shipDontShipSurgery = useSelector(
        (state) => state.loginReducer.shipDontShipSurgery
    );
    const isCondensedView = useSelector(
        (state) => state.loginReducer.isCondensedView
    );
    let validBatch = batchLocations
        ? batchLocations?.batchAllocations?.find(
              (batch) => batch.id === nonTissueProduct?.batchAllocation?.id
          )
            ? true
            : false
        : false;
    useEffectWithErrorLogging(() => {
        if (batchLocations && !visitedShipping) {
            dispatch(
                updateCartDataShipping({ shippingRequirement: true }, [
                    productKey,
                ])
            );
        }
    }, [batchLocations]);

    return (
        <>
            {shipDontShipSurgery !== 'NOT_VISIBLE' && isShowCheckBox && (
                <Checkbox 
                    checked={checked}
                    onCheckboxSelectionChange={checkBoxClick}
                    label={
                        isShowLabelEmpty
                            ? ''
                            : t(
                                  'scheduleSurgery.Shipping.ProductCard.DontShipSet'
                              )
                    }
                    disabled={inventoryShipping}
                    margin={'0 6px 0 0'}
                    labelStyleObj={{
                        fontSize: SEMANTIC_TEXT_SMALL_PX,
                        fontFamily: FONT_FAMILY_DEMI,
                        color: DARK_NAVY_FONT_COLOR,
                    }}
                    id='surgery-shipping-Nt-CheckboxwithTransferFailedWithDropdown'
                    background={'none'}
                    checkboxBorder={'1.5px solid #555555'}
                    alignItemDirection={'center'}
                    hoverEffect={'false'}
                    disableFocusEffect={'true'}
                />
            )}
           
                <>
                    {isShowSetLocation && isMessageDisplay && (
                        <StyledText
                            fontColor={DARK_GRAY_FONT_COLOR}
                            fontSize={SMALL_TEXT_PX}
                            fontFamily={FONT_FAMILY_DEMI}
                            margin="12px 0px 0px 0px"
                        >
                            {t(
                                'scheduleSurgery.Shipping.ProductCard.SetLocation'
                            )}
                        </StyledText>
                    )}

                    {!checked && isMessageDisplay ? (
                        isCondensedView ? (
                            <TransferSurgeryErrorDiv>
                                <TransferSurgeryErrorTitlerDiv>
                                    <ErrorOutlineRounded
                                        style={{
                                            width: '26px',
                                            height: '26px',
                                            color: validBatch ? '#A3001E' : '#B56409',
                                            alignSelf: 'baseline',
                                            paddingBottom:'4px',
                                            paddingRight:'5px'
                                        }}
                                    />
                                    <TransferSurgeryRedText
                                        fontSize="13px"
                                        mbFontSize="14px"
                                        lineHeight="23px"
                                        fontFamily="AvenirNextWorld Regular"
                                        color={
                                            validBatch ? '#A3001E' : '#B56409'
                                        }
                                    >
                                        {t(
                                            'scheduleSurgery.Shipping.ProductCard.TransferFailed'
                                        ) +
                                            ' ' +
                                            (nonTissueProduct?.batchAllocation?.id?.trim() &&
                                            (avoidDeploymentType(countryISOCode)
                                                ? true
                                                : nonTissueProduct
                                                      ?.batchAllocation
                                                      ?.isParked)
                                                ? `: ${t(
                                                      'scheduleSurgery.Shipping.BatchLocationCard.batchLabel'
                                                  )} ` +
                                                  ' ' +
                                                  nonTissueProduct
                                                      ?.batchAllocation?.id
                                                : '') +
                                            ' ' +
                                            (validBatch
                                                ? t(
                                                      'scheduleSurgery.Shipping.NonTissuecomponents.msg'
                                                  )
                                                : t(
                                                      'scheduleSurgery.Shipping.ProductCard.TransferFailedMessage'
                                                  ))}
                                    </TransferSurgeryRedText>
                                </TransferSurgeryErrorTitlerDiv>
                            </TransferSurgeryErrorDiv>
                        ) : (
                            <TransferSurgeryErrorDiv>
                                <TransferSurgeryErrorTitlerDiv>
                                    <img
                                        src={AlertCircleOutline}
                                        height="15px"
                                        style={{
                                            margin: '-3px 5px 0px 0px',
                                        }}
                                        width="auto"
                                    />
                                    <TransferSurgeryRedText
                                        fontSize="14px"
                                        mbFontSize="14px"
                                        lineHeight="23px"
                                        fontFamily="AvenirNextWorld Demi"
                                    >
                                        {t(
                                            'scheduleSurgery.Shipping.ProductCard.TransferFailed'
                                        ) +
                                            ' ' +
                                            (nonTissueProduct?.batchAllocation?.id?.trim() &&
                                            (avoidDeploymentType(countryISOCode)
                                                ? true
                                                : nonTissueProduct
                                                      ?.batchAllocation
                                                      ?.isParked)
                                                ? `: ${t(
                                                      'scheduleSurgery.Shipping.BatchLocationCard.batchLabel'
                                                  )} ` +
                                                  ' ' +
                                                  nonTissueProduct
                                                      ?.batchAllocation?.id
                                                : '')}
                                    </TransferSurgeryRedText>
                                </TransferSurgeryErrorTitlerDiv>
                                <TransferSurgeryBlackText
                                    fontSize="12px"
                                    mbFontSize="12px"
                                    lineHeight="19px"
                                    margin={'0 0 0 19px'}
                                >
                                    {validBatch
                                        ? t(
                                              'scheduleSurgery.Shipping.NonTissuecomponents.msg'
                                          )
                                        : t(
                                              'scheduleSurgery.Shipping.ProductCard.TransferFailedMessage'
                                          )}
                                </TransferSurgeryBlackText>
                            </TransferSurgeryErrorDiv>
                        )
                    ) : (
                        isShowDropDown && (
                            <>
                                <DropdownWithErrorText
                                    AlertCircleOutline={AlertCircleOutline}
                                    nonTissueProduct={nonTissueProduct}
                                    batchLocations={batchLocations}
                                    selectedBatchLocationTemplate={
                                        selectedBatchLocationTemplate
                                    }
                                    batchLocationTemplate={
                                        batchLocationTemplate
                                    }
                                    selectedLocation={selectedLocation}
                                    handleLocationChange={handleLocationChange}
                                    checked={checked}
                                />
                            </>
                        )
                    )}
                </>
            
        </>
    );
};

export default NtCheckboxwithTransferFailedWithDropdown;
